import styled, { css } from 'styled-components';
import { IconColor } from '../../../Icon/styles';

export type MenuProps = {
  menuOpen?: boolean;
};

export type BurgerIconStyleProps = {
  fillColor: IconColor;
};

const BurgerLine = styled.span`
  display: block;
  border-radius: 999px;
  transition: transform 0.3s ease-out, width 0.3s ease-out;

  height: 3px;
`;

export const TopBurgerLine = styled(BurgerLine)`
  margin: 4px 0;
`;
export const MiddleBurgerLine = styled(BurgerLine)`
  margin: 7px 0;
`;
export const BottomBurgerLine = styled(BurgerLine)`
  margin: 4px 0;
`;

const translateYPx = '10px';

const closedMenuStyles = css`
  ${TopBurgerLine}, ${BottomBurgerLine} {
    width: 80%;
  }

  ${MiddleBurgerLine} {
    width: 100%;
  }
`;

const openedMenuStyles = css`
  ${TopBurgerLine} {
    transform: translateY(${translateYPx}) rotate(45deg);
  }

  ${MiddleBurgerLine} {
    transform: scaleY(0);
  }

  ${BottomBurgerLine} {
    transform: translateY(-${translateYPx}) rotate(-45deg);
  }
`;

export const BurgerContainer = styled.div<MenuProps & BurgerIconStyleProps>`
  height: 32px;
  width: 32px;

  > ${BurgerLine} {
    background: ${({ fillColor }) => fillColor};
  }

  ${({ menuOpen }) => (menuOpen ? openedMenuStyles : closedMenuStyles)}
`;

// To be included in any component that needs burger animation, e.g. the mobile nav menu button
export const burgerEventStyles = css`
  &:hover,
  &:focus-visible,
  &:active {
    ${TopBurgerLine}, ${BottomBurgerLine} {
      width: 100%;
    }

    ${MiddleBurgerLine} {
      width: 80%;
    }
  }

  &:active {
    ${TopBurgerLine} {
      transform: translateY(${translateYPx});
    }

    ${MiddleBurgerLine} {
      transform: scaleY(0);
    }

    ${BottomBurgerLine} {
      transform: translateY(-${translateYPx});
    }
  }
`;
